import { components } from "@/lib/ApiSchema";
import Input from "./Input";
import useOperationContext from "./useOperationContext";
import useGetCurrentQuoteRevision from "@/lib/SelectedQuoteRevisionIdContext/useGetCurrentQuoteRevision";

export default function VolumeDiscount() {
  const { operationData, updateOperation } = useOperationContext();
  const { id, augmented, draft } = operationData;
  const discount_rates: components["schemas"]["VolumeDiscounts"] =
    draft?.discount_rates ??
    (augmented as { discount_rates: components["schemas"]["VolumeDiscounts"] })
      ?.discount_rates;

  const canEditQuoteRevision = useGetCurrentQuoteRevision()?.can_edit;

  return (
    <div
      className={`flex flex-col gap-1 text-xs text-gray-400 border rounded-sm ${discount_rates.enabled ? "border-slate-100" : "border-transparent"} p-1`}
    >
      <label className="flex gap-2">
        <input
          tabIndex={-1}
          disabled={!canEditQuoteRevision}
          type="checkbox"
          name="volumeDiscount"
          checked={discount_rates.enabled}
          onChange={() => {
            updateOperation(id, {
              ...draft,
              discount_rates: {
                ...discount_rates,
                enabled: !discount_rates.enabled,
              } as never,
            });
          }}
        />
        Volume Discount
      </label>
      <table className={`${!discount_rates.enabled && "invisible"}`}>
        <thead>
          <tr>
            <td scope="col" className="text-left pr-4">
              Quantity
            </td>
            <td scope="col" className="text-left">
              Discount
            </td>
          </tr>
        </thead>
        <tbody>
          {discount_rates.tiers?.map((_, i) => (
            <tr key={i}>
              <td className="pt-1">
                <Input
                  keyPath={["discount_rates", "tiers", i, "min_qty"]}
                  suffix="+"
                  alignRight={false}
                />
              </td>
              <td className="pt-1">
                <Input
                  keyPath={["discount_rates", "tiers", i, "rate"]}
                  suffix="%"
                  width={50}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
